// assets/collections-by-type.js
document.addEventListener('DOMContentLoaded', async () => {
 
  const container = document.querySelector('[data-metafield-namespace]');
  if (!container) return;
 
  const namespace = container.dataset.metafieldNamespace;
  const key = container.dataset.metafieldKey;
  const value = container.dataset.metafieldValue;
  const shopDomain = container.dataset.shopDomain;
  const token = "10f8be35de51ef9bbd2aca0b488dc0af";
  const imageRatio = container.dataset.imageRatio || 'square';
  const displayMode = container.dataset.displayMode || 'grid';
  const columns = container.dataset.columns || '4';
  const columnsMobile = container.dataset.columnsMobile || '1';

  async function fetchAllCollections(cursor = null, all = []) {
    const query = `
      query getCollections($cursor: String) {
        collections(first: 250, after: $cursor) {
          edges {
            cursor
            node {
              id
              handle
              title
              image {
                url
                altText
              }
              products(first: 1) {
                edges {
                  node {
                    featuredImage {
                      url
                      altText
                    }
                  }
                }
              }
              metafield(namespace: "${namespace}", key: "${key}") {
                value
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;

    const res = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables: { cursor } })
    });

    const json = await res.json();
    
    const edges = json?.data?.collections?.edges || [];
    const newCollections = edges.map(e => e.node);
    all.push(...newCollections);

    if (json.data.collections.pageInfo.hasNextPage) {
      const nextCursor = edges[edges.length - 1].cursor;
      return fetchAllCollections(nextCursor, all);
    }

    return all;
  }

  function renderCard(collection) {
    const locale = Shopify?.locale || 'fr';
    const prefix = locale === 'en' ? '' : `/${locale}`;
    const link = `${prefix}/collections/${collection.handle}`;
    
    if (displayMode === 'list') {
      return `
        <div class="card card--list">
          <a href="${link}" class="text-base font-medium block hover:underline">${collection.title}</a>
        </div>
      `;
    }
    let imgUrl = collection.image?.url;
    let altText = collection.image?.altText || collection.title;

    if (!imgUrl && collection.products?.edges?.length > 0) {
      const productImage = collection.products.edges[0].node.featuredImage;
      if (productImage) {
        imgUrl = productImage.url;
        altText = productImage.altText || collection.title;
      }
    }
    let ratio = imageRatio;
    if (ratio === 'adapt' && !imgUrl) {
      ratio = 'wide';
    }
    
    
    return `
      <div class="card media-card media-card--card">
        <a class="media-card__link" href="${link}">
          ${imgUrl ? `<div class="media media--${ratio} relative overflow-hidden"><img src="${imgUrl}" alt="${altText}" /></div>` : ''}
          <div class="media-card__content flex justify-between items-center gap-4 w-full text-left">
          <div class="media-card__text shrink-1 grid gap-0d5">
            <p>
              <span class="heading reversed-link text-xl-3xl tracking-tighter leading-tight relative font-bold">${collection.title}</span>
                  </p></div><svg class="icon icon-arrow-right icon-xs transform shrink-0" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"></path>
            </svg>
          </div>
        </a>
      </div>
    `;
  }

  const allCollections = await fetchAllCollections();
  const matching = allCollections.filter(c => {
    try {
      const values = JSON.parse(c.metafield?.value || '[]');
      return Array.isArray(values) && values.includes(value);
    } catch (e) {
      console.warn('Metafield parsing error:', c.metafield?.value);
      return false;
    }
  });
  const sorted = matching.sort((a, b) => {
    return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
  });
 
  if (displayMode === 'alpha') {
   
    let currentLetter = '';
    let html = '';
  
    sorted.forEach((collection) => {
      const firstLetter = collection.title.trim().charAt(0).toUpperCase();
      const letter = /[0-9]/.test(firstLetter) ? '0-9' : firstLetter;
      const locale = Shopify?.locale || 'fr';
      const prefix = locale === 'en' ? '' : `/${locale}`;
      const link = `${prefix}/collections/${collection.handle}`;
     
      
      if (letter !== currentLetter) {
        // Fermer la liste précédente si nécessaire
        if (currentLetter !== '') {
          html += '</div>'; // ferme le groupe précédent
        }
        html += `<div class="alpha-group"><h3 class="letter-separator">${letter}</h3>`;
        currentLetter = letter;
      }
  
      html += `
        <div class="card card--list">
          <a href="${link}" class="text-base font-medium block hover:underline">
            ${collection.title}
          </a>
        </div>
      `;
    });
  
    html += '</div>'; // ferme le dernier groupe
    container.innerHTML = html;
    document.querySelector('.loadingspinner').style.display = 'none';
  }
  else{
    container.innerHTML = sorted.map(renderCard).join('');
    document.querySelector('.loadingspinner').style.display = 'none';
  }
  
});